const mapping = {
  A: 1,
  B: 2,
  C: 3,
  D: 4,
  E: 5,
  F: 6,
  G: 7,
  H: 8,
  I: 9,
  J: 1,
  K: 2,
  L: 3,
  M: 4,
  N: 5,
  O: 6,
  P: 7,
  Q: 8,
  R: 9,
  S: 2,
  T: 3,
  U: 4,
  V: 5,
  W: 6,
  X: 7,
  Y: 8,
  Z: 9,
  Ä: 1,
  Ö: 6,
  Ü: 4,
  "0": 0,
  "1": 1,
  "2": 2,
  "3": 3,
  "4": 4,
  "5": 5,
  "6": 6,
  "7": 7,
  "8": 8,
  "9": 9
};
const weights = {
  "1": 9,
  "2": 8,
  "3": 7,
  "4": 6,
  "5": 5,
  "6": 4,
  "7": 3,
  "8": 2,
  "9": 10,
  "10": 9,
  "11": 8,
  "12": 7,
  "13": 6,
  "14": 5,
  "15": 4,
  "16": 3,
  "17": 2
};

export function calculateVinChecksum(vin: string): number {
  let sum = 0;
  for (let i = 0; i < vin.length; i++) {
    sum = sum + weights[i + 1] * mapping[vin.charAt(i)];
  }
  if (isNaN(sum % 11)) {
    return -1;
  } else {
    return sum % 11;
  }
}
